<template>
  <v-layout>
    <v-layout v-if="extendedGuests.length" column>
      <secondary-button
        v-for="(extendedGuest, i) in extendedGuests"
        :key="i"
        @click="$router.push({ name: routeNames.guest.name, params: { id: extendedGuest.guest.id } })"
        :disabled="isGuestDisabled(extendedGuest.guest)"
        class="mt-5 overflow-ellipsis"
        appendIcon="mdi-arrow-right"
        :text="getGuestFullName(extendedGuest)">
        <template v-slot:appendContent v-if="isChild(extendedGuest.guest)">
          <img class="ml-2" height="30" src="@/assets/lollipop.png">
        </template>
      </secondary-button>
    </v-layout>
    <span v-else class="no-visitors">{{ $t('main.no_visitors') }}</span>
  </v-layout>
</template>

<script>
import routeNames from '@/router/routes'
import moment from 'moment'
import { mapGetters } from 'vuex'
import vuetifyMixins from '@/mixins/Vuetify'
import { getGuestFullName } from '@/lib/helpers/Guest'

export default {
  data () {
    return {
      moment,
      routeNames,
      getGuestFullName
    }
  },
  computed: {
    ...mapGetters({
      extendedGuests: 'bookings/extendedGuests',
      isChild: 'me/isGuestChild',
      isGuestDisabled: 'guests/getIsGuestDisabled',
      isBookingDisabled: 'bookings/isBookingDisabled'
    })
  },
  components: {
    SecondaryButton: () => import('@/components/app-components/SecondaryButton.vue')
  },
  mixins: [
    vuetifyMixins
  ]
}
</script>

<style lang='scss' scoped>
.no-visitors {
  color: lightgray;
  font-size: 40px;
}
.overflow-ellipsis {
  text-overflow: ellipsis;
  display: block;
}
</style>
